var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContentmanagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20.3 18.9",
    style: {
      enableBackground: "new 0 0 20.3 18.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "background"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -1,
    className: "st0",
    width: 20,
    height: 20
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "document_x5F_text_x5F_accept"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.9,8.3V3.6l-3.1-3.1H1.5v17.8h13.3v0c2.5-0.3,4.4-2.4,4.4-5C19.3,10.7,17.4,8.6,14.9,8.3z M11.5,1.8l2,2h-2 C11.5,3.8,11.5,1.8,11.5,1.8z M2.6,17.2V1.6h7.8v3.3h3.3v3.4c-1,0.1-1.9,0.5-2.6,1.1H3.8v1.1h6.4c-0.2,0.3-0.4,0.7-0.6,1.1H3.8v1.1 h5.6c0,0.2,0,0.4,0,0.6c0,1.6,0.7,3,1.9,3.9H2.6z M14.3,17.1c-2.1,0-3.8-1.7-3.8-3.8c0-2.1,1.7-3.8,3.8-3.8c2.1,0,3.8,1.7,3.8,3.8 C18.1,15.4,16.4,17.1,14.3,17.1z M12.7,7.2H3.8v1.1h8.9V7.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "11.5,13.3 12.7,12.2 13.8,13.3 16,11.1 17.1,12.2 13.8,15.5  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentmanagement);
export default __webpack_public_path__ + "static/media/contentmanagement.6473d0c8c950a433ba123d7f8fc96d34.svg";
export { ForwardRef as ReactComponent };